import { ToggleButton } from 'vue-js-toggle-button';
import { VueEditor } from "vue2-editor";
import { Datetime } from 'vue-datetime';
import SectorService from '../../../services/Sector.js';
import Multiselect from 'vue-multiselect';
import moment from 'moment';

if($('#network-settings').length){
    var app = new Vue({
        el: '#network-settings',
        data: {
            network:null,
            account:{
                accountType:{}
            },
            loadingMessage:'Loading Network Editor',
            newUserEmail:'',
            selectedSector: null,
            loading:true,
            sidebar:true,
            uploaderErrors:[],
            sectors:[],
            networkSlug: networkSlug,
            networkGroupSlug: networkGroupSlug,
            currentUserId: currentUserId,
            originalAnonymous: true,
        },
        methods: {
            getAccountByUser(){
                axios.get('/api/v1/account/current-user')
                .then((response) =>  {
                    this.account = response.data;
                })
                .catch((error) =>  {
                    if(error.response){
                        this.$toasted.error(error.response.data);
                    }
                    this.loading = false;
                })
            },
            getNetwork(slug){
                axios.get('/api/v1/network/'+slug)
                .then((response) =>  {
                    this.originalAnonymous = response.data.anonymous;
                    response.data.innovations_level = response.data.innovations_level_id != 4 ? true : false;
                    response.data.experts_level = response.data.experts_level_id != 4 ? true : false;
                    response.data.feed_level = response.data.feed_level_id != 4 ? true : false;

                    this.network = response.data;
                    this.account = this.network.account;
                    if(this.network && this.network.expiry_date){
                        this.network.expiry_date = moment(this.network.expiry_date).toISOString();
                    }
                    if (this.network && this.network.start_date) {
                        this.network.start_date = moment(this.network.start_date).toISOString();
                    }

                    this.network.anonymous = this.network.anonymous ? true : false;

                    this.$nextTick(function () {
                        this.loading = false;
                        $(".tooltipped").tooltip();
                    });
                })
                .catch((error) =>  {
                    this.$toasted.error(error.response.data);
                    this.loading = false;
                })
            },
            saveNetwork(status = null){
                if(this.validate()){
                    var form =  document.getElementById('network-settings');
                    var formData = new FormData(form);
                    formData = this.appendFields(formData);
                    if(status == 'archive'){
                        formData.append('network_status_slug', status);
                    }

                    this.loading = true;
                    this.loadingMessage = 'Saving Network';

                    axios.post('/api/v1/network/'+this.network.slug, formData)
                    .then((response) =>  {
                        this.getNetwork(this.networkSlug);

                        if(this.network.anonymous && !this.originalAnonymous){
                            window.location.replace("/organisation/anonymous/"+this.network.slug+"/administration/settings");
                        }

                        this.$toasted.success('Your Network has been Saved');
                    })
                    .catch((error) =>  {
                        this.$toasted.error(error.response.data);
                        this.loading = false;
                    });
                }
            },
            changeAnonymous(){
                console.log(this.network.anonymous, this.originalAnonymous);
                if(this.network.anonymous && !this.originalAnonymous){
                    this.network.anonymous = false;
                    if(confirm("Switching an already created branded Challenge to an anonymous Challenge will remove it from its organisation and place it under an 'anonymous' organisation. This will also change all URL's to access your Challenge.")){
                        this.network.anonymous = true;
                        this.saveNetwork();
                    }
                }else{
                    this.saveNetwork();
                }
            },
            archiveNetwork(){
                if(confirm("Are you sure you want to archive this? People will no longer be able to apply however you will still be able to see applications")){
                    this.saveNetwork('archive');
                }
            },
            getSectorSlug(){
                var sectorID = this.network.sector_id;
                var sector = this.sectors.filter(obj => {
                    return obj.id === sectorID;
                });
                return sector[0].slug;
            },
            addNetworkUser(){
                if(!this.newUserEmail){
                    this.$toasted.error('Please add an email address');
                    return;
                }

                this.loading = true;
                this.loadingMessage = 'Looking for User';

                axios.post('/api/v1/find-user', {
                    'email':this.newUserEmail,
                    'type': 'network',
                    'type_id': this.network.slug
                })
                .then((response) =>  {
                    if (response.data === 'New user') {
                        if (!this.network.hasOwnProperty('invited')) {
                            this.network.invited = [];
                        }
                        this.network.invited.push(this.newUserEmail);
                        this.newUserEmail = '';
                        this.saveNetwork();
                        this.$toasted.success('Collaborator added, please save to apply changes');
                    } else {
                        let newUser = response.data;

                        let existingUser = this.network.admins.filter(user => {
                            return user.id === newUser.id;
                        });

                        this.newUserEmail = '';

                        if (!existingUser.length) {
                            this.network.admins.push(newUser);

                            this.saveNetwork();
                            this.$toasted.success('Network user added.');
                        } else {
                            this.$toasted.error('This user has already been added to your Network.');
                        }
                    }

                    this.$nextTick(function () {
                        this.loading = false;
                    });

                })
                .catch((error) =>  {
                    this.$toasted.error(error.response.data);
                    this.loading = false;
                });
            },
            removeUser(index){
                this.network.admins.splice(index, 1);

                this.saveNetwork();
            },
            removeInvitedUser(index){
                this.network.invited.splice(index, 1);
                this.saveNetwork();
            },
            makeOwner(id){
                this.network.owner_id = id;
                this.saveNetwork();
            },
            appendFields(formData) {
                formData.append('sectors', this.network.sectors.map(sector => sector.id));
                formData.append('expiry_date', this.network.expiry_date);
                formData.append('start_date', this.network.start_date);

                if(!this.network.innovations_level){
                    formData.append('innovations_level_id', 4);
                }else{
                    if(this.network.innovations_level_id == 4){
                        formData.append('innovations_level_id', 3);
                    }
                }

                if(!this.network.experts_level){
                    formData.append('experts_level_id', 4);
                }else{
                    if(this.network.experts_level_id == 4){
                        formData.append('experts_level_id', 3);
                    }
                }

                if(!this.network.feed_level){
                    formData.append('feed_level_id', 4);
                }else{
                    if(this.network.feed_level_id == 4){
                        formData.append('feed_level_id', 3);
                    }
                }

                formData.append('anonymous', this.network.anonymous ? 1 : 0);
                formData.append('show_scoring', this.network.show_scoring ? 1 : 0);
                formData.append('disable_vetting', this.network.disable_vetting ? 1 : 0);
                formData.append('auto_approve', this.network.auto_approve ? 1 : 0);
                formData.append('require_profile_completion', this.network.require_profile_completion ? 1 : 0);
                formData.append('require_innovation_completion', this.network.require_innovation_completion ? 1 : 0);
                formData.append('hide_cover_note', this.network.hide_cover_note ? 1 : 0);

                formData.append('owner_id', this.network.owner_id);
                let adminIds = this.getAdminIds();
                formData.append('adminIds', adminIds);

                formData.append('invited', this.network.invited);

                return formData;
            },
            getAdminIds(){
                return this.network.admins.map(admin => admin.id);
            },
            validate(){
                let network = this.network;

                if(!network.innovations_level && !network.experts_level){
                    this.$toasted.error('You must have at least one of Innovations or Experts enabled');
                    return false;
                }

                return true;
            },
            getTime(time){
                var testDateUtc = moment.utc(time);
                var localDate = testDateUtc.local();
                return localDate.format('LLL');
            },
        },
        mounted () {
            SectorService.getSectors().then(data => {
                this.sectors = data;
            });

            this.getNetwork(this.networkSlug);
        },
        updated: function () {
        },
        components: {
            'multiselect': Multiselect,
            'ToggleButton': ToggleButton,
            'vue-editor': VueEditor,
            'SectorService': SectorService,
            'Datetime': Datetime
        },
    });
}